import { forwardRef, useState } from 'react'
import { v4 as uuid } from 'uuid'
import { StyledSegmentedRoot } from '../styled-components'
import { SegmentedContext } from './segmented-context'
import PropTypes from 'prop-types'
import { segmentedActivationModeOptions } from '../constants'

const SegmentedRoot = forwardRef((props, forwardedRef) => {
  const {
    value: valueProp,
    onValueChange,
    defaultValue,
    activationMode = segmentedActivationModeOptions.AUTOMATIC,
    disabled = false,
    loading = false,
    ...segmentedProps
  } = props

  const [componentValue, setComponentValue] = useState(defaultValue)

  const value = valueProp ?? componentValue
  const setValue = onValueChange ?? setComponentValue

  const contextValue = {
    baseId: uuid(),
    value,
    onValueChange: setValue,
    activationMode,
    disabled,
    loading
  }

  return (
    <SegmentedContext.Provider value={contextValue}>
      <StyledSegmentedRoot {...segmentedProps} ref={forwardedRef} />
    </SegmentedContext.Provider>
  )
})

SegmentedRoot.propTypes = {
  value: PropTypes.string,
  onValueChange: PropTypes.func,
  defaultValue: PropTypes.string,
  activationMode: PropTypes.oneOf(
    Object.values(segmentedActivationModeOptions)
  ),
  disabled: PropTypes.bool,
  loading: PropTypes.bool
}

SegmentedRoot.displayName = 'SegmentedRoot'
export default SegmentedRoot
